import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { propertyCardPhotoHeaderStyles } from './styles/property-card-photo-header.styles';
import type { PropertyCardPhotoHeaderPropsInterface } from './types/property-card-photo-header.types';

/**
 * A container that appears at the top of a property photo in a `PropertyCard`.
 * Usually contains a `PropertyCard.Badge`.
 *
 * @since 8.63.0
 */
export const PropertyCardPhotoHeader = forwardRef<
  HTMLDivElement,
  PropertyCardPhotoHeaderPropsInterface
>((props: PropertyCardPhotoHeaderPropsInterface, forwardedRef) => {
  const { children, className, css: cssProp, ...rest } = props;

  const styles = css(propertyCardPhotoHeaderStyles, cssProp);

  return (
    <div
      ref={forwardedRef}
      data-c11n-component="PropertyCard.PhotoHeader"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', 'c11n_property-card__photo-header', styles, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

PropertyCardPhotoHeader.displayName = 'PropertyCard.PhotoHeader';
